import { Component } from 'react'
import { Autocomplete, Box, Paper, TextField } from '@mui/material'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { Colors } from '../../../Styles/Colors'
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import { ToolsField } from '../../../Components/Common Components/CommonComponents'
import { localGetItem } from '../../../Utility/Services/CacheProviderService'
import { GetInvestigationName } from '../../../Components/CommonFunctions/CommonFunctions'


export default class RadAddTemplate extends Component {
    constructor(props) {
        super(props)
        let propData = this.props.history?.location?.state?.templateData
        this.state = {
            serviceTypeList: [],
            serviceNameList: [],
            selectedServiceType: propData?.service_type ? propData?.service_type : null,
            selectedServiceName: propData?.service_name ? propData?.service_name : null,
            templateName: propData?.template_name ? propData?.template_name : '',
            resultData: propData?.template_data ? propData?.template_data : '',
            selectedId: propData?.id ? propData?.id : null,
            postLoad: false,
            HeaderList: [],
            ServiceList: [],
            DupServiceList: [],
        }
    }

    componentDidMount() {
        this.getFOServiceConfigData()
    }

    getFOServiceConfigData = () => {
        try {
            RestAPIService.getAll(Serviceurls.NEW_DEPARTMENT_MASTER + `?module_type=${JSON.parse(localGetItem('loggedInUserInfo'))?.module_name === "Investigation" ? GetInvestigationName() : "RADIOLOGY"}&charge_type=Normal`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const allData = response.data?.data || [];

                        const uniqueHeaderList = Array.from(
                            new Map(allData.map(item => [item.service_head, item])).values()
                        );

                        const uniqueServiceList = Array.from(
                            new Map(allData.map(item => [item.service_name, item])).values()
                        );

                        this.setState({
                            HeaderList: uniqueHeaderList,
                            DupServiceList: uniqueServiceList,
                        }, () => {
                            let propData = this.props.history?.location?.state?.templateData;

                            const selectedServiceType = uniqueHeaderList.find(
                                item => item.service_head === propData?.service_head
                            );

                            const selectedServiceName = uniqueServiceList.find(
                                item => item.service_name === propData?.service_name
                            );

                            this.setState({
                                selectedServiceType: selectedServiceType || null,
                                selectedServiceName: selectedServiceName || null,
                            });
                        })
                    }
                }).catch((error) => {
                    this.errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    checkValidation = (resultData) => {
        try {
            let message = null;

            if (this.state.selectedServiceName === null || this.state.selectedServiceType === null || this.state.templateName === '' || resultData.trim() === '') {
                message = 'Please,Enter all mandatory fields'
            }
            return message;
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    postNewTemplateData = (resultData) => {
        try {
            let check = this.checkValidation(resultData)
            if (check === null) {
                let data = {
                    service_head: this.state.selectedServiceName?.service_head ? this.state.selectedServiceName?.service_head : this.state.selectedServiceName,
                    service_name: this.state.selectedServiceType?.service_name ? this.state.selectedServiceType?.service_name : this.state.selectedServiceType,
                    template_name: this.state.templateName,
                    template_data: resultData
                }
                if (this.state.selectedId) {
                    data['template_id'] = this.state.selectedId
                }
                this.setState({ postLoad: true })
                let ApiUrl = JSON.parse(localGetItem('loggedInUserInfo'))?.module_name === "Investigation" ? Serviceurls.INVESTIGATION_TEST_TEMPLATE_CONFIG_NEW : Serviceurls.RAD_TEST_TEMPLATE_CONFIG_NEW
                RestAPIService.create(data, ApiUrl)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            this.successMessage(response.data.message)
                            this.onClearHandler()
                            this.setState({ postLoad: false })
                            setTimeout(() => {
                                this.props.history?.push({ pathname: `/${GetInvestigationName()}Settings/ServiceTemplateConfig` })
                            }, 800)
                        }
                    }).catch((error) => {
                        this.setState({ postLoad: false })
                        this.errorMessage(error?.response?.data?.message || error?.message)
                    })
            } else {
                this.setState({ postLoad: false })
                this.errorMessage(check)
            }

        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    onClearHandler = () => {
        try {
            this.setState({
                selectedServiceName: null,
                selectedServiceType: null,
                templateName: '',
                resultData: '',
                selectedId: null
            })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    handleHeadChange = (event, value) => {
        const { DupServiceList } = this.state;
        const filteredServices = value ? DupServiceList?.filter(item => item?.service_head === value?.service_head) : [];

        this.setState({
            selectedServiceType: value,
            ServiceList: filteredServices
        }, () => {
            if (!value) {
                this.setState({
                    selectedServiceName: null
                })
            }
        });
    };

    handleServiceChange = (event, value) => {
        this.setState({
            selectedServiceName: value
        });
    };

    render() {
        return (
            <Box component={'div'}>
                <Box component={'div'} className='rad_tst_container' sx={{ backgroundColor: Colors.Background }}>
                    <Box component={'div'} className='rad_tst_tmp_header'>
                        <Paper component={'div'} className='rad_srv_tmp_pap' elevation={1}>
                            <Autocomplete
                                options={this.state.HeaderList}
                                clearIcon={false}
                                value={this.state.selectedServiceType}
                                getOptionLabel={(option) => option?.service_head || ''}
                                onChange={this.handleHeadChange}
                                sx={{ ml: '0.3vw' }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Service Head *"
                                        variant="outlined"
                                        size="small"
                                        sx={{ width: "15vw" }}
                                    />
                                )}
                            />
                            <Autocomplete
                                options={this.state.ServiceList}
                                clearIcon={false}
                                value={this.state.selectedServiceName}
                                getOptionLabel={(option) => option?.service_name || ''}
                                onChange={this.handleServiceChange}
                                sx={{ ml: '0.3vw' }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Service Name *"
                                        variant="outlined"
                                        size="small"
                                        sx={{ width: "15vw", marginLeft: "1vw", marginRight: "1vw" }}
                                    />
                                )}
                            />
                            <TextField
                                sx={{ width: '15vw' }}
                                size='small'
                                value={this.state.templateName}
                                label='Template Name *'
                                onChange={(e) => {
                                    let value = e.target.value
                                    if (CommonValidation.alphabetOnly(value)) {
                                        this.setState({ templateName: value })
                                    }
                                }}
                            />
                        </Paper>
                    </Box>
                    <ToolsField
                        Title={"Result*"}
                        EditorRef={this.state.resultData}
                        handlePost={this.postNewTemplateData.bind(this)}
                        height={"54vh"}
                        overallHeight={"67vh"}
                        EditorHeight={"53vh"}
                        addSpaceOnTab={true} />
                </Box>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
}